/**
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

M.View = M.View || {};

/**
 * @class SSLProxy
 *
 * Handles ajax requests over SSL. SSLProxy operates
 * within the iframe created by IframeSSLProxy.
 */

(function(M, _, $, Backbone) {
  "use strict";

  // Private sslProxyInstance used for the static getInstance function.
  var sslProxyInstance;

  M.View.SSLProxy = Backbone.View.extend({

    initialize: function() {
      _.bindAll(this, 'ajaxReceiver');
      this.createPostMessageHandler();
      return this;
    },

    /**
     * Creates this.messageHandler, which targets the parent window.
     */
    createPostMessageHandler: function() {
      this.sender = new M.PostMessageSender(window.parent,
        this.options.parentOrigin);
      this.receiver = new M.PostMessageReceiver();
      this.receiver.receive('ajax', this.ajaxReceiver);
    },

    /**
     * Make an ajax call.
     *
     * @param {Object} options See http://api.jquery.com/jQuery.ajax/
     */
    ajaxReceiver: function(options) {
      var that = this;
      // Mock success, error, and complete callbacks to send
      // response data back to the target (window.parent).
      _.each(['complete', 'success', 'error'], function(callbackOption) {
        options[callbackOption] = function() {
          var args = _.toArray(arguments);
          args.unshift(callbackOption); // Prepend callbackOption to args.
          that.sender.send.apply(that.sender, args);
        };
      });
      $.ajax(options);
    }

  }, {

    // Static functions

    getInstance: function(options) {
      if (sslProxyInstance) {
        return sslProxyInstance;
      } else {
        sslProxyInstance = new M.View.SSLProxy(options);
        return sslProxyInstance;
      }
    }

  });

})(M, _, $, Backbone);
